import React from 'react';
import { useGTContext } from '../GTContext';
import { IconEdit } from 'src/components/CommonMenu/icons/IconEdit';
import * as S from './GTCInlineWrapper.styles';

interface GTCInlineWrapperProps {
  children: React.ReactNode;
}

export const GTCInlineWrapper: React.FC<GTCInlineWrapperProps> = ({ children }) => {
  const { itemHeight } = useGTContext();

  return (
    <S.Div $itemHeight={itemHeight} onClick={(e) => e.stopPropagation()} className="gt-inline-wrapper">
      {children}
      <S.EditIndicator>
        <IconEdit />
      </S.EditIndicator>
    </S.Div>
  );
};
